import { UploadCloud, ScanEye, Clapperboard } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const SectionHead = ({ label, title, sub }) => (
  <div className="max-w-2xl mb-12">
    <div className="cx-label">{label}</div>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-3">{title}</h2>
    {sub && <p className="text-slate-400 mt-4 leading-relaxed">{sub}</p>}
  </div>
);

const STEPS = [[UploadCloud, "ld.s1_t", "ld.s1_d"], [ScanEye, "ld.s2_t", "ld.s2_d"], [Clapperboard, "ld.s3_t", "ld.s3_d"]];

export const HowItWorks = () => {
  const { t } = useI18n();
  return (
    <section id="how" className="relative pt-10 pb-16 sm:py-24 scroll-mt-20" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead label={t("ld.how_label")} title={t("ld.how_title")} />
        <div className="grid md:grid-cols-3 gap-5">
          {STEPS.map(([Icon, tk, dk], i) => (
            <div key={tk} className={`cx-card cx-card-hover rounded-2xl p-7 relative overflow-hidden ${i === 1 ? "md:translate-y-8" : ""}`} data-testid={`how-step-${i + 1}`}>
              <span className="absolute -right-3 -top-6 font-display text-[120px] font-black text-white/[0.03] select-none">{i + 1}</span>
              <div className="w-12 h-12 rounded-xl grid place-items-center bg-gradient-to-br from-[#2f7bff]/25 to-[#a746ff]/25 border border-white/10">
                <Icon className="w-6 h-6 text-[#3ad7ff]" />
              </div>
              <div className="font-mono text-[11px] text-[#a746ff] mt-6">0{i + 1}</div>
              <h3 className="font-display text-xl font-semibold text-white mt-1">{t(tk)}</h3>
              <p className="text-sm text-slate-400 mt-3 leading-relaxed">{t(dk)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
